const icons = {
  ADD: 'add',
  ADD_CIRCLE: 'add_circle',
  AHU: 'ahu',
  ALARM_URGENT: 'urgent_alarm',
  ARROW_DOWN: 'arrow_down',
  ARROW_UP: 'arrow_up',
  AUDIT_TRAIL: 'audit_trail',
  BACKUP: 'backup',
  BARLINE_CHART: 'barline_chart',
  BELL: 'bell',
  BUZZER_MUTE: 'buzzer_mute',
  BUZZER_ON: 'buzzer_on',
  CALENDAR: 'calendar',
  CARWASH: 'carwash',
  CASE_EVAPORATOR: 'case_evaporator',
  CASE_FAN: 'case_fan',
  CAUTION: 'caution',
  CHECK_CIRCLE: 'check',
  CHECKMARK: 'checkmark',
  CHEVRON_DOWN: 'chevron-down',
  CIRCLE: 'circle',
  CIRCLE_CLOSE: 'circle_close',
  CLEAR_ALARM: 'clear_alarm',
  CLOCK: 'clock',
  CLOSE: 'close',
  CLOUD_QUESTION: 'cloud_question',
  COG: 'cog',
  COLLAPSE: 'collapse',
  COLUMNS_CONFIG: 'columns_config',
  COMFORT: 'comfort',
  COMPUTER: 'computer',
  CONDENSER: 'condenser',
  CONNECTED: 'connected',
  CONNECTED_CLOUD: 'connected_cloud',
  CONTROLS: 'controls',
  COPY: 'copy',
  CRITICAL_ALARMS: 'criticalAlarms',
  CSV: 'csv',
  CUBE: 'cube',
  DANFOSS: 'danfoss',
  DB: 'db',
  DB_EXPORT: 'db-export',
  DB_IMPORT: 'db-import',
  DEFROST: 'defrost',
  DEVICE_IO: 'io',
  DEVICE_WIRELESS: 'device_wireless',
  DIAGNOSTIC: 'diagnostic',
  DIAGNOSTIC_CIRCLE: 'diagnostic_circle',
  DIGITAL_INPUT: 'digital_input',
  DISCONNECTED: 'disconnect',
  DISCONNECTED_CLOUD: 'disconnected_cloud',
  DOOR_EXIT: 'door-exit',
  DOOR_OPEN: 'door_open',
  DOTS_HORIZONTAL: 'dots_horizontal',
  DOTS_HORIZONTAL_CIRCLE: 'dots_horizontal_circle',
  DOTS_VERTICAL: 'dots_vertical',
  DOUBLE_ARROW: 'double_arrows',
  DOWNLOAD: 'download',
  DOWNLOAD_CIRCLE: 'download_circle',
  DOWNLOAD_FILE: 'download_file',
  ECO: 'eco',
  EDF_UPDATE: 'edf_update',
  EDIT_PENCIL: 'edit_pencil',
  ELECTRICS: 'electrics',
  ENERGY_LEAF: 'energy_leaf',
  ENERGY_PLUG: 'energy_plug',
  ENVELOPE: 'envelope',
  ERROR_BUBBLE_FILLED: 'error_bubble_filled',
  ERROR_CIRCLE: 'error',
  EVENT_LOG: 'event_log',
  EXPAND: 'expand',
  EXTERNAL: 'external',
  EYE: 'eye',
  EYE_OFF: 'eye_off',
  FAN: 'fan',
  FILE: 'file',
  FILLED_ARROW_LEFT: 'filled_arrow_left',
  FILLED_ARROW_RIGHT: 'filled_arrow_right',
  FILTER: 'filter',
  FLAGGED: 'flagged',
  FOLDER: 'folder',
  FONT_SIZE_DOWN: 'font_size_down',
  FONT_SIZE_UP: 'font_size_up',
  FROST: 'frost_protection',
  GAUGE: 'gauge',
  GLOBE: 'globe',
  GOOGLE: 'google',
  GRAPH: 'graph',
  GRAPHICEDIT: 'graphedit',
  GROUP_OF_LOCATIONS: 'group_of_locations',
  HACCP: 'haccp',
  HAMBURGER: 'hamburger',
  HEALTH_CHECK: 'health_check',
  HEAT_RECLAIM: 'heat_reclaim',
  HEATING: 'heating',
  HELP_CIRCLE: 'help',
  HOLIDAY_UMBRELLA: 'holiday_umbrella',
  HOME: 'home',
  HP_CONTROL: 'hp_control',
  HVAC: 'hvac',
  HVAC_COPY: 'hvac_copy',
  HVAC_LAYOUT: 'hvac_layout',
  IMPORT: 'import',
  INFO_BUBBLE_FILLED: 'info_bubble_filled',
  INFO_CIRCLE: 'info',
  INFO_FILLED: 'info_filled',
  INSIDE_TEMP: 'inside_temp',
  KEY: 'key',
  LIGHTING: 'lighting',
  LIGHTING_ZONE: 'lighting_zone',
  LINK: 'link',
  LIST: 'list',
  LIST_VIEW_BORDERED: 'list_view_bordered',
  LOCATION: 'location',
  LOCATION_FILLED: 'location_filled',
  LOCATION_SEARCH: 'locationSearch',
  LOCATION_SHADDOW: 'location_shadow',
  LOCK: 'lock',
  MAP_MARKER: 'mapMarker',
  MENU: 'menu',
  MENU_DOT: 'menu_dot',
  METER: 'meter',
  MIMICS: 'mimics',
  MISC: 'misc',
  MISC_CALCULATION: 'misc_calculation',
  MISC_LEAK_SENSOR: 'misc_leak_sensor',
  MISC_MANAGER_OVERRIDE: 'misc_manager_override',
  MISC_ON_OFF: 'misc_on_off',
  MISC_RELAY_OUTPUT: 'misc_relay_output',
  MISC_SENSOR_INPUT: 'misc_sensor_input',
  MISC_VARIABLE_OUTPUT: 'misc_variable_output',
  MIXED_DATA: 'mixedData',
  NIGHT_SETBACK: 'night_setback',
  NO_ACCESS: 'no_access',
  NO_EQUIPMENT: 'no_equipment',
  NO_LINK: 'no_link',
  NOT_FOUND: 'not_found',
  NOTE_IC: 'note_ic',
  NOTIFICATION: 'notification',
  OPENING_HOURS: 'opening_hours',
  OPPOSITE_ARROWS: 'opposite_arrows',
  OS_UPDATE: 'os_update',
  OUTSIDE_TEMP: 'outside_temp',
  PACK_RACK: 'pack_rack',
  PARAMETERS: 'parameters',
  PAUSE_CIRCLE: 'pause_circle',
  PDF: 'pdf',
  PENCIL: 'pencil',
  PIE_CHART: 'pie_chart',
  PLANET: 'planet',
  PUMP: 'pump',
  RECEIVER: 'receiver',
  REDO: 'redo',
  REFRESH: 'refresh',
  REFRIG_COPY: 'refrig_copy',
  REFRIG_LAYOUT: 'refrig_layout',
  REFRIGERATION: 'refrigeration',
  REFRIGERATION_GROUP: 'refrigeration_group',
  REMOVE: 'remove',
  REMOVE_CIRCLE: 'remove_circle',
  REORDER: 'reorder',
  REPORT: 'report',
  REPORTS: 'reports',
  ROLLBACK: 'rollback',
  RTU: 'rtu',
  SAVE: 'save',
  SCREWDRIVER: 'screwdriver',
  SEARCH: 'search',
  SETTINGS: 'settings',
  SHARE: 'share',
  SHUT_DOWN: 'shut_down',
  SITE_STATUS_CONNECTED: 'site_status_connected',
  SITE_STATUS_NOT_AVAILABLE: 'site_status_not_available',
  SITE_STATUS_WARNING: 'site_status_warning',
  SOFTWARE_UPDATE: 'software_update',
  STACK: 'stack',
  STAR: 'star',
  STAR_FILLED: 'star_filled',
  STAR_HALF_FILLED: 'star_half_filled',
  STOREVIEW: 'storeview',
  SUCCESS_BUBBLE_FILLED: 'success_bubble_filled',
  SUCTION_GROUP: 'suction_group',
  TAG: 'tag',
  TAP_WATER: 'tap_water',
  THERMOMETER: 'thermometer',
  TILE_VIEW: 'tile_view',
  TILE_VIEW_BORDERED: 'tile_view_bordered',
  TRASH: 'trash',
  UNDO: 'undo',
  UPDATE: 'update',
  UPLOAD: 'upload',
  USER: 'user',
  USERS: 'users',
  VALVE: 'valve',
  WARNING: 'warning',
  WARNING_CIRCLE: 'warning_circle',
  WARNING_FILLED: 'warning_filled',
  WIRELESS: 'wireless',
  ZOOM_IN: 'zoom_in',
  ZOOM_OUT: 'zoom_out'
};

export { icons };
